/**
 * Catálogo de strings (ADR-024). pt-PT primeiro; en-GB entra quando necessário.
 * Na interface da clínica dizemos "utente"; no código, `patient`.
 */
const ptPT = {
  'app.name': 'Nolens Physio',
  'app.endorsement': 'by rdoria.com',
  'nav.attention': 'Atenção',
  'nav.patients': 'Utentes',
  'nav.library': 'Biblioteca',
  'nav.messages': 'Mensagens',
  'nav.results': 'Resultados',
  'nav.settings': 'Definições',
  'nav.today': 'Hoje',
  'nav.week': 'Semana',
  'nav.profile': 'Perfil',
  'auth.signOut': 'Terminar sessão',
} as const;

export type MessageKey = keyof typeof ptPT;

export function t(key: MessageKey): string {
  return ptPT[key];
}

export function greeting(now = new Date()): string {
  const h = now.getHours();
  if (h < 12) return 'Bom dia';
  if (h < 20) return 'Boa tarde';
  return 'Boa noite';
}

export function firstName(name: string | null | undefined): string {
  return name?.trim().split(/\s+/)[0] ?? '';
}
